import BaseView from "../core/views/BaseView";
import C_PointerEvt from "../core/const/C_PointerEvt";
import Button from "../core/ui/Button";
import C_Local from "../core/const/C_Local";


class RoomSelectView extends BaseView
{

    constructor()
    {
        super();

        document.body.style.cursor = "url('styles/custom_cursor1.png') 5 5, auto";
        this.create();
    }


    create()
    {
        this.addBackground();
        this.addBalanceInfo();
        this.addRooms();
        this.addButtons();
    }


    addLogo() {}


    addBackground()
    {
        this.layout.propHeightScale(this.bg, 100);
        this.layout.verticalAlignMiddle(this.bg);
        this.layout.horizontalAlignCenter(this.bg);
        this.addChild(this.bg);

        // let bgOver = new PIXI.Graphics();
        // bgOver.beginFill(0xffffff, 0.75);
        // bgOver.drawRect(this.bg.x, this.bg.y, this.bg.width, this.bg.height);
        // this.addChild(bgOver);
    }


    addBalanceInfo()
    {
        this.balanceBg = this.assets.getSprite("player_balance_bg");
        this.layout.propHeightScale(this.balanceBg, 12);
        this.layout.verticalAlignTop(this.balanceBg);
        this.layout.horizontalAlignRight(this.balanceBg);
        this.addChild(this.balanceBg);

        let txtSize = this.layout.relHeight(20, this.balanceBg);

        let balanceTF = this.assets.getTF("BALANCE", txtSize, null, "#ffd800");
        this.layout.verticalAlignTop(balanceTF, 12.5, this.balanceBg);
        balanceTF.x = this.balanceBg.x + this.balanceBg.width*0.15;
        this.addChild(balanceTF);

        let coin1 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin1, 25, this.balanceBg);
        this.layout.verticalAlignTop(coin1, 10, this.balanceBg);
        coin1.x = this.balanceBg.x + this.balanceBg.width*0.35;
        this.addChild(coin1);

        let balancePoints = this.assets.getTF(this.model.getBalance(), txtSize);
        this.layout.verticalAlignTop(balancePoints, 12.5, this.balanceBg);
        balancePoints.x = coin1.x + coin1.width + this.balanceBg.width*.01;
        this.addChild(balancePoints);

        let balanceCurrency = this.assets.getTF("$" + (this.model.getBalance()/this.model.getCurrencyMultiplier()).toString(), txtSize);
        this.layout.verticalAlignTop(balanceCurrency, 12.5, this.balanceBg);
        balanceCurrency.x = this.balanceBg.x + this.balanceBg.width*.6;
        this.addChild(balanceCurrency);

        let coin2 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin2, 25, this.balanceBg);
        this.layout.verticalAlignTop(coin2, 10, this.balanceBg);
        coin2.x = this.balanceBg.x + this.balanceBg.width*0.79;
        this.addChild(coin2);

        let exchangeValue = this.assets.getTF("= $" + this.model.getCoinsRate(), txtSize, null, "#ffd800");
        this.layout.verticalAlignTop(exchangeValue, 12.5, this.balanceBg);
        exchangeValue.x = coin2.x + coin2.width + this.balanceBg.width*.01;
        this.addChild(exchangeValue);
    }


    addRooms()
    {
        let textSize = this.layout.relHeight(6);
        let shipSizes = [120, 120, 140];
        let betRanges = ["1-9", "10-90", "100-1000"];
        // this.textColor = [0x00baff, 0x3fccc2, 0x00c120];
        // this.textOverColor = [0xffd800, 0xff9a16, 0xff7700];

        // grey image colors
        // let roomTint = [0xff4200, 0xdeff00, 0x00d2ff];
        // this.roomTint = [0x00d000, 0xffff00, 0xff0000]; // green / yellow / red
        // this.roomTint = [0xffff00, 0x00deff, 0xb955ff]; // yellow / blue / purple
        // this.roomTint = [0x00deff, 0x00d000, 0xffff00]; // blue / green / yellow

        // COMBINE COLORS: blue: 0x00deff/0x82fffa, purple: 0xb955ff/0xcf8cff, yellow: 0xffff00/0xffff91,
        // blue: 0x00baff/0x60d3ff
        this.roomTint = [0x00deff, 0xb955ff, 0xffff00]; // blue / purple / yellow
        this.roomTintOver = [0x82fffa, 0xcf8cff, 0xffff91]; // OVER: blue / purple / yellow
        this.textColor = [0x00deff, 0xb955ff, 0xffff00];
        this.textOverColor = [0x82fffa, 0xcf8cff, 0xffff91];


        let roomData = this.model.getRoomData();
        let numRooms = roomData.length;

        for (let butIdx=0; butIdx < numRooms; butIdx++)
        {
            let roomBut = new PIXI.Container();

            let roomBg = this.assets.getSprite("room_bg_gray");
            this.layout.propHeightScale(roomBg, 45);
            roomBut.addChild(roomBg);
            roomBg.tint = this.roomTint[butIdx];

            let roomBorder = this.assets.getSprite("room_bg_border_gray");
            this.layout.propHeightScale(roomBorder, 45);
            roomBut.addChild(roomBorder);
            roomBorder.tint = this.roomTint[butIdx];

            let roomTF = this.assets.getTF("Room " + (butIdx+1), textSize, null, "#00baff");
            roomTF.style.fill = this.textColor[butIdx];
            this.layout.verticalAlignTop(roomTF, 12, roomBg);
            this.layout.horizontalAlignCenter(roomTF, 0, roomBg);
            roomBut.addChild(roomTF);

            let roomBet = this.assets.getTF(betRanges[butIdx], textSize, null, "#00baff");
            roomBet.style.fill = this.textColor[butIdx];
            this.layout.verticalAlignBottom(roomBet, 10, roomBg);
            this.layout.horizontalAlignCenter(roomBet, 0, roomBg);
            roomBut.addChild(roomBet);

            let roomShip = this.assets.getSprite("room_ship_" + (butIdx+1));
            this.layout.propWidthScale(roomShip, shipSizes[butIdx], roomBg);
            this.layout.verticalAlignMiddle(roomShip, 0, roomBg);
            this.layout.horizontalAlignCenter(roomShip, 0, roomBg);
            roomBut.addChild(roomShip);

            this.layout.verticalAlignMiddle(roomBut);
            let xPos = (butIdx - (numRooms - 1) * .5) * 30;
            this.layout.horizontalAlignCenter(roomBut, xPos);
            this.addChild(roomBut);
            roomBut.interactive = true;
            roomBut.on(C_PointerEvt.DOWN, this.onRoomSelected, this);
            roomBut.on(C_PointerEvt.OVER, this.onRoomOver, this);
            roomBut.on(C_PointerEvt.OUT, this.onRoomOver, this);
            roomBut.roomType = butIdx;
        }
    }


    onRoomOver(e)
    {
        if(!e) return;

        let but = e.currentTarget;
        let bg = but.getChildAt(1);
        let tf = but.getChildAt(2);
        let bet = but.getChildAt(3);

        if (e.type == C_PointerEvt.OVER)
        {
            // bg.texture = this.roomBgTextureOver;
            bg.tint = this.roomTintOver[but.roomType];
            tf.style.fill = this.textOverColor[but.roomType];
            bet.style.fill = this.textOverColor[but.roomType];
        }
        else if (e.type == C_PointerEvt.OUT)
        {
            // bg.texture = this.roomBgTexture;
            bg.tint = this.roomTint[but.roomType];
            tf.style.fill = this.textColor[but.roomType];
            bet.style.fill = this.textColor[but.roomType];
        }
    }


    onRoomSelected(e)
    {
        this.controller.selectRoom(e.target.roomType);
    }


    addButtons()
    {
        this.paytableButton = new Button("paytable_but", "paytable_but_glow", "paytable_but_glow");
        this.layout.propHeightScale(this.paytableButton, 10);
        this.layout.horizontalAlignLeft(this.paytableButton, 3);
        this.layout.verticalAlignTop(this.paytableButton, 10);
        this.addChild(this.paytableButton);


        let soundSkin = this.localData.getBooleanValue(C_Local.SOUND_ENABLED, this.soundEnabled) ? "btnSound" : "btnSoundOff";
        this.soundButton = new Button(soundSkin, soundSkin, soundSkin);
        this.layout.propHeightScale(this.soundButton, 10);
        this.layout.horizontalAlignRight(this.soundButton, 3);
        this.layout.verticalAlignTop(this.soundButton, 10);
        this.addChild(this.soundButton);

        this.paytableButton.on(C_PointerEvt.DOWN, this.onPaytable, this);
        this.soundButton.on(C_PointerEvt.DOWN, this.onSoundTrigger, this);
    }


    onPaytable(e)
    {
        if (e)
        {
            e.stopPropagation();
        }
        this.controller.openPaytable();
    }


    onSoundTrigger(e)
    {
        if (e)
        {
            e.stopPropagation();
        }

        this.sound.toggleMusic();
        this.sound.toggleSound();

        let soundSkin = this.localData.getBooleanValue(C_Local.SOUND_ENABLED, this.soundEnabled) ? "btnSound" : "btnSoundOff";
        this.soundButton.setSkins(soundSkin, soundSkin, soundSkin, soundSkin);
    }

}

export default RoomSelectView